<button type="button" class="rest-info button button--th-ctrl" (click)="onChooseAddress()">
  <div class="rest-info__body">
    <div class="rest-info__address h4" *ngIf="{selectedDeliveryType: selectedDeliveryType$ | async} as data">
      <ng-container [ngSwitch]="data.selectedDeliveryType">
        <ng-container *ngSwitchCase="deliveryTypes.Delivery">
          <ng-container *ngIf="deliveryAddress$ | async as deliveryAddress; else emptyAddress">
            <span class="rest-info__street" title="{{ deliveryAddress.line1 }}">
              <ng-container *ngIf="deliveryAddress.street">
                {{ deliveryAddress.street }}&nbsp;{{ deliveryAddress.house }},&nbsp;{{deliveryAddress.city}}
              </ng-container>
              <ng-container *ngIf="!deliveryAddress.street">
                {{ deliveryAddress.city }},&nbsp;{{ deliveryAddress.house }}
              </ng-container>
            </span>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="deliveryTypes.Pickup">
          <ng-container *ngIf="address$ | async as address; else restoInfo">
            <span class="rest-info__street" title="{{ address }}">{{ addressDetails$ | async }}</span>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="address$ | async as address; else restoInfo">
            <span class="rest-info__street" title="{{ address }}">{{ addressDetails$ | async }}</span>
          </ng-container>
        </ng-container>
      </ng-container>

    </div>
  </div>
</button>
<ng-container *ngTemplateOutlet="workingHours"></ng-container>
<!--    https://stackoverflow.com/a/56653661 -->
<ng-container *ngIf="breakPoint.isMobile && false">
  <button type="button" class="rest-info button button--th-ctrl" *ngIf="address$ | async as address;">
    <div class="rest-info__body">
      <div class="rest-info__address h4">
        <a href="https://maps.google.com/?q={{ address }}" target="_blank" class="link">
          <a href="https://maps.apple.com/maps?q={{ address }}" target="_blank" class="link">
            <ng-container *ngIf="address$ | async as address; else restoInfo">
              <span title="{{ address }}">{{ address }}</span>
            </ng-container>
          </a>
        </a>
      </div>
    </div>
  </button>
</ng-container>

<ng-template #workingHours>
  <ng-container
    *ngIf="{
      selectedDeliveryType: selectedDeliveryType$ | async,
      deliveryAddress: deliveryAddress$ | async,
      workingHours: getWorkingHours(activeOutlet$ | async, this.selectedDeliveryType$ | async, deliveryAvailableIntervals$ | async)
    } as data"
  >
    <button
      *ngIf="(data.selectedDeliveryType !== deliveryTypes.Delivery || data.deliveryAddress) && data.workingHours"
      type="button"
      class="rest-info working-hours button button--th-ctrl"
      (click)="onChooseWorkingHours()">
      <div class="rest-info__body">
        <div class="rest-info__address">
          <span class="rest-info__caption">

            <ng-container [ngSwitch]="data.selectedDeliveryType">
              <ng-container *ngSwitchCase="deliveryTypes.Delivery">
                <i class="icomoon icomoon--courier"></i>
                <span i18n="@@Delivery" class="small">Delivery</span>
              </ng-container>
              <ng-container *ngSwitchCase="deliveryTypes.Pickup">
                <span i18n="@@DeliveryByClient" class="small">Pickup</span>
              </ng-container>
              <ng-container *ngSwitchCase="deliveryTypes.Eatin">
                <span i18n="@@DineInOrder" class="small">Dine-in order</span>
              </ng-container>
            </ng-container>
            &nbsp;
            <span class="small">{{data.workingHours}}</span>

          </span>
        </div>
      </div>
    </button>
  </ng-container>
</ng-template>

<ng-template #restoInfo>
  <ng-container *ngIf="noOutlets$ | async; else noAddress">
    <p i18n="@@EmptyOutlesMessage">Restaurant is closed</p>
  </ng-container>
  <ng-template #noAddress>
    <p i18n="@@EmptyHeadAddressMessage">Address is empty</p>
  </ng-template>
</ng-template>


<ng-template #emptyAddress>
  <span>
    <i class="icomoon icomoon--pin"></i>
    <span i18n="@@ChooseAddressPlaceholder">Choose address</span>
  </span>
</ng-template>
